import axios from 'axios'

import env from '../environments'

export async function track(eventName: string, data?: Record<string, any> | undefined) {
	try {
		await axios.post(`${env.apiUrl}/obiwan/kenobi`, {
			eventName,
			data
		})
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Failed to track event:', error)
	}
}
